import {NgModule} from "@angular/core";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {BrowserModule} from "@angular/platform-browser";



import {Component, ElementRef}            from '@angular/core';
//import {HTTP_PROVIDERS}			  from '@angular/http';
import { HttpModule } from '@angular/http';

import {ContentRow}			    from './content-row';
import {RequirementsTableComponent}	from './requirements-table.component';
import {ContentService}		  	from './content.service';

//import {provide}				      from '@angular/core';
import {XHRBackend}				    from '@angular/http';

import {Injectable}            from '@angular/core';
import {Input} from "@angular/core";

import { appConfig } from '../assets/config/app.config';

@Injectable()
export class UrlVars {

	constructor() { }

	getUrlVars() {
		var vars = [], hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}
}

@Injectable()
export class MainCategoryId {
	constructor(private _urlVars: UrlVars) {
		debugger;
		this.catId = this._urlVars.getUrlVars()['mainCatId'] || 1;
	}

	public catId: string = '1';

}

@Component({
    selector: 'requirementsView',
    template: `
		<requirements-table></requirements-table>
	`,
    //directives:[ContentListComponent],
    providers: [
        //HTTP_PROVIDERS,
        ContentService
    ]
})
export class RequirementsViewComponent { constructor() { debugger; } }

@Component({
    selector: 'pageCategoryTitle',
    template: `
		{{this.categoryText}}
	`,
	providers: [
		UrlVars,
		MainCategoryId
	]
})
export class PageCategoryTitleComponent {

    constructor(private _mainCategoryId: MainCategoryId) {
        debugger;

        /*
		this.categoryText = this._mainCategoryId.catId == '1' ?
			appConfig.buildingPermitsTitle :
            appConfig.businessLicensingTitle;
        */

        switch (this._mainCategoryId.catId) {
            case '1':
                {
                    this.categoryText = appConfig.buildingPermitsTitle;
                    break;
                }

            case '2':
                {
                    this.categoryText = appConfig.businessLicensingTitle;
                    break;
                }

            case '5':
                {
                    this.categoryText = appConfig.assetRequirementTitle;
                    break;
                }
        }

		document.title = this.categoryText;
	}

    public categoryText: string;
}

@Component({
    selector: 'pageCategoryText',
    //  template: `
	//	<div *ngIf="this._catId == this._mainCategoryId.catId">{{this.innerHtml}}</div>
	//`,
	templateUrl: './pageCategoryText.component.html',
	providers: [
		UrlVars,
		MainCategoryId
	]
})
export class PageCategoryTextComponent {

    constructor(private _mainCategoryId: MainCategoryId) {
		debugger;
		this._catId = this._mainCategoryId.catId;
	}

	//@Input('catId')
	private _catId: string = '1';

	//private innerHtml: string;
}


//@NgModule({
//    declarations: [RequirementsViewComponent, RequirementsTableComponent],
//    imports: [BrowserModule, HttpModule],
//    bootstrap: [RequirementsViewComponent],
//    providers: []
//})
//export class AppModule {

//}

//platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/requirements.component.ts